import React, { type PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

type Props = PropsWithChildren<{ ns: string[]; fallback?: React.ReactNode }>;

export default function RequireNS({ ns, fallback = null, children }: Props) {
  const { ready } = useTranslation(ns, { useSuspense: false });
  if (!ready) {
    return <>{fallback}</>;
  }
  return <>{children}</>;
}
